/**
 * Eligible zipcodes for Mpox Vaccine Study
 * Virginia and North Carolina regions
 * Total zipcodes: 164
 */
export const mpoxEligibleZipCodes: readonly string[] = [
  // Virginia zipcodes (23xxx range)
  "23001", "23003", "23018", "23021", "23025", "23045", "23056", "23061",
  "23062", "23072", "23081", "23090", "23107", "23109", "23119", "23125",
  "23127", "23128", "23130", "23131", "23138", "23154", "23155", "23163",
  "23178", "23183", "23184", "23185", "23186", "23187", "23188", "23304",
  "23310", "23313", "23314", "23315", "23316", "23320", "23321", "23322",
  "23323", "23324", "23325", "23326", "23327", "23328", "23397", "23419",
  "23424", "23429", "23430", "23431", "23432", "23433", "23434", "23435",
  "23436", "23437", "23438", "23439", "23443", "23450", "23451", "23452",
  "23453", "23454", "23455", "23456", "23457", "23458", "23459", "23460",
  "23461", "23462", "23463", "23464", "23465", "23466", "23467", "23471",
  "23479", "23487", "23501", "23502", "23503", "23504", "23505", "23506",
  "23507", "23508", "23509", "23510", "23511", "23513", "23514", "23515",
  "23517", "23518", "23519", "23523", "23529", "23541", "23551", "23601",
  "23602", "23603", "23604", "23605", "23606", "23607", "23608", "23609",
  "23612", "23628", "23630", "23651", "23661", "23662", "23663", "23664",
  "23665", "23666", "23667", "23668", "23669", "23670", "23681", "23690",
  "23691", "23692", "23693", "23694", "23696", "23701", "23702", "23703",
  "23704", "23705", "23707", "23708", "23709", "23837", "23839", "23846",
  "23851", "23866", "23878", "23881", "23883", "23888", "23890", "23898",
  "23899",

  // North Carolina zipcodes (27xxx range)
  "27926", "27929", "27935", "27937", "27938", "27946", "27950", "27958",
  "27969", "27976", "27979",
] as const;
